<template>
  <div class="ak-color-picker__color-type">
    <span class="ak-color-picker__color-name">
      {{ name }}
    </span>
    <input v-model="modelColor" class="ak-color-picker__color-value" />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-color-picker-color-box />
   */
  name: 'AkColorPickerColorBox',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    name: {
      type: String,
      default: '',
    },

    color: {
      type: String,
      default: '',
    },
  },

  emits: ['inputColor'],

  setup(props, { emit }) {
    const modelColor = computed({
      get() {
        return props.color
      },

      set(val) {
        emit('inputColor', val)
      },
    })

    return {
      modelColor,
    }
  },
})
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../scss/_settings.scss';
.ak-color-picker {
  $self: &;
  &__color-type {
    display: flex;
    margin-top: 8px;
    font-size: 12px;
  }

  &__color-name {
    width: 60px;
    height: 30px;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    background: $color-grey-darker;
    border-radius: $base-border-radius 0 0 $base-border-radius;
    #{$self}--light & {
      background: $color-grey-lightest;
      border: $base-border;
      color: $color-text;
    }
  }

  &__color-value {
    flex: 1;
    min-height: 30px;
    height: 30px;
    min-width: 100px;
    padding: 0 12px;
    border: 0;
    color: #fff;
    background: $color-grey-darker;
    box-sizing: border-box;
    border-radius: 0 $base-border-radius $base-border-radius 0;
    #{$self}--light & {
      background: $color-grey-lightest;
      border: $base-border;
      border-left: 0;
      color: $color-text;
    }
  }
}
</style>
